import {
  Vue,
  Component,
} from 'vue-property-decorator';

@Component
export default class ValidationErrorMixin extends Vue {
  public getValidationErrors(validations: any): Array<string> {
    const errors: Array<string> = [];
    if (!validations || validations.$error === false || validations.$invalid === false) {
      return errors;
    }
    if (validations.required === false) {
      errors.push('Обязательное поле');
    }
    return errors;
  }
}
